interface IndexItem {
  title: string;
  count: string;
  icon: string;
}

const indexItems: IndexItem[] = [
  { title: '动作电影', count: '856部', icon: 'ri-sword-line' },
  { title: '喜剧电影', count: '623部', icon: 'ri-emotion-laugh-line' },
  { title: '爱情电影', count: '541部', icon: 'ri-heart-line' },
  { title: '科幻电影', count: '389部', icon: 'ri-rocket-line' },
  { title: '恐怖悬疑', count: '312部', icon: 'ri-ghost-line' },
  { title: '国产剧集', count: '1,203部', icon: 'ri-tv-2-line' },
  { title: '韩剧精选', count: '487部', icon: 'ri-kakao-talk-line' },
  { title: '美剧精选', count: '398部', icon: 'ri-global-line' },
  { title: '热门综艺', count: '629部', icon: 'ri-live-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            分类导航
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            主题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按类型快速筛选，精准找到你想看的内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={item.title}
              href="#hero"
              className={`group flex flex-col items-center gap-3 p-5 md:p-6 rounded-2xl border border-background-200/80 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                i >= 5 ? 'lg:col-span-1' : ''
              }`}
            >
              <div
                className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl transition-colors ${
                  i % 3 === 0
                    ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50'
                    : i % 3 === 1
                    ? 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50'
                    : 'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50'
                }`}
              >
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                {item.title}
              </span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}